import styled from "styled-components";
import colors from "../../../constants/colors";

export const Container = styled("div")({
  background: `
    radial-gradient(circle at 20% 10%, rgba(116, 105, 182, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 80% 90%, rgba(173, 136, 198, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 50% 50%, rgba(225, 175, 209, 0.03) 0%, transparent 70%),
    ${colors.BACKGROUND}
  `,
  borderRadius: "15px",
  padding: "1rem",
  color: colors.BLACK,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "0.75rem",
  direction: "rtl",
});

export const CurrentCard = styled("div")({
  backgroundColor: colors.WHITE,
  borderRadius: "10px",
  padding: "1rem",
  width: "100%",
  maxWidth: "360px",
  textAlign: "center",
  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
  color: colors.BLACK,
});

export const CardHeadline = styled("div")({
  fontSize: "1rem",
  fontWeight: 600,
  marginBottom: "0.25rem",
});

export const CardSubline = styled("div")({
  fontSize: "0.85rem",
  color: colors.GREY_6,
});
